export const AboutData = [
  {
    label: "About",
    value: "about",
    index: 0,
    desc: [
      "Full name :  : Imène ALLOUCHE",
      "Age       :  : 21 years old",
      "Education :  : 4th year Student at Higher National School of Computer Science ESI (Algiers)",
      "Work      :  : MERN stack Web developer freelancer",
      "Position  :  : Web development inscructor at BrainerX",
      "Interests :  : CTF player and Cybersecurity enthusiast",
    ],

    router: "",
    completed: false,
  },
  {
    label: "Positions",
    value: "experience",
    index: 1,
    desc: [
      `2024-Currently      :    Technical Deparment Manager of Shellmates Club`,

      `2024-2025           :    Penetration Tester Intern at Keystone Group`,

      `2023-2024           :    Cybersecurity Insctructor at Code Labs Academy`,

      `2023-2024           :    Shellmates Club Vice President`,

      `2022-2023           :    Communication Department Manager  of Shellmates Club`,

      `2022-currently      :    CTF player at noreply team`,
    ],
    router: "",
    completed: false,
  },
  {
    label: "Rewards",
    value: "rewards",
    index: 2,
    desc: [
      `2024-Currently      :    Technical Deparment Manager of Shellmates Club`,

      `2024-2025           :    Penetration Tester Intern at Keystone Group`,

      `2023-2024           :    Cybersecurity Insctructor at Code Labs Academy`,

      `2023-2024           :    Shellmates Club Vice President`,

      `2022-2023           :    Communication Department Manager  of Shellmates Club`,

      `2022-currently      :    CTF player at noreply team`,
    ],
    router: "",
    completed: false,
  },
  {
    label: "Resume",
    value: "rewards",
    index: 3,
    desc: [
      `2024-Currently      :    Technical Deparment Manager of Shellmates Club`,

      `2024-2025           :    Penetration Tester Intern at Keystone Group`,

      `2023-2024           :    Cybersecurity Insctructor at Code Labs Academy`,

      `2023-2024           :    Shellmates Club Vice President`,

      `2022-2023           :    Communication Department Manager  of Shellmates Club`,

      `2022-currently      :    CTF player at noreply team`,
    ],
    router: "",
    completed: false,
  },
];
